import { BusinessInfo, CommerceConf } from '@gooduncles/gu-app-schema';
import { FC, PropsWithChildren, createContext, useContext, useEffect, useState } from 'react';
import { getBusinessInfoConf, observeCommerceConf } from 'src/utils/firebase/firebase-short-cut';

const initCommerceConf: CommerceConf = {
  open: false,
  openAt: 6,
  closeAt: 23,
  deliveryDateRules: [1, 1, 1, 1, 1, 1, 2],
  closed: {
    isClosed: false,
    msgClosed: '죄송합니다. 현재는 주문이 불가능합니다.',
  },
  deliveryFee: 3000,
  minAmountForFreeDelivery: 50000,
  notice: null,
  minVersion: null,
  minConsoleVersion: null,
  minCommerceWebVersion: null,
  /** 아래 정보는 console에서만 사용된다. */
  packingInfoSheet: {
    egg: {
      supplierIds: [],
      purchaseBundles: [],
    },
    green_onion: {
      supplierIds: [],
      purchaseBundles: [],
    },
    garlic: {
      supplierIds: [],
      purchaseBundles: [],
    },
  },
  partnersTaskAssignTime: '00:30',
  purchaseOrderInquiryNumber: '1234567890',
};

const initBusinessInfo: BusinessInfo = {
  businessAddress: '경기도 하남시 감초로132번길 76-35(감북동) 굿엉클스',
  businessName: '주식회사 굿엉클스',
  businessNumber: '123-45-67890',
  ownerName: '박근철',
};

interface AppContext {
  showLoading: boolean;
  setShowLoading: (show: boolean) => void;
  commerceConf: CommerceConf;
  businessInfo: BusinessInfo;
}

const appContext = createContext<AppContext | null>(null);

const useProvideApp = () => {
  const [businessInfo, setBusinessInfo] = useState<BusinessInfo>(initBusinessInfo);
  const [commerceConf, setCommerceConf] = useState<CommerceConf>(initCommerceConf);
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    const subscription = observeCommerceConf().subscribe((conf) => {
      setCommerceConf(conf);
    });
    getBusinessInfoConf().then((doc) => {
      if (doc) {
        setBusinessInfo(doc);
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return {
    showLoading,
    setShowLoading,
    commerceConf,
    businessInfo,
  };
};

export const AppProvider: FC<PropsWithChildren<any>> = ({ children }) => {
  const value = useProvideApp();
  return <appContext.Provider value={value}>{children}</appContext.Provider>;
};

export const useApp = () => {
  const context = useContext(appContext);
  if (context == null) {
    throw new Error('Out of context: appProvider is not set');
  }
  return context;
};
